import Vue  from 'vue'
import Vuex from 'vuex'
//
import roadModule     from '@/store/roadMap'
import generalModule  from '@/store/general'
import progressModule from '@/store/progressMap'
import certModule     from '@/store/certMap'
import hobbyModule    from '@/store/hobbyMap'
import contactsModule from '@/store/contactsMap'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    roadModule,
    generalModule,
    progressModule,
    certModule,
    hobbyModule,
    contactsModule
  }
})
